import ApiService from '@/core/services/api.service';

/** Giống NK 72: resolve productCode (+ Tổng cộng, Giá vốn…) → có productId. */
export function postOpeningStockSlipValidateImportProduct(body) {
  return ApiService.post('v1/opening-stock-slip/validate-import-product', body);
}

/** Giống NK 73: resolve productCode + IMEI serial → có productId (và thường có imeiId nếu backend trả). */
export function postOpeningStockSlipValidateImportImei(body) {
  return ApiService.post('v1/opening-stock-slip/validate-import-imei', body);
}
